import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { FileLogger } from "src/app/helpers/fileLogger";
import { IKnowledges } from "src/app/helpers/knowledge-helper";
import { Tools } from "src/app/helpers/tools-helper";
import { IKeyValue } from "src/app/models/keyValue";
import { KnowledgeKeyValueService } from "../knowledge-key-value.service";
import { AccountService } from "./account.service";
import { BasicSyncService, INeedRefresh } from "./core/basic-sync.service";
import { DataService } from "./core/data.service";
import { StaticImplements } from "src/app/models/sharedInterfaces";

@Injectable({
  providedIn: "root",
})
export class KnowledgesFAQService
  extends BasicSyncService<IKnowledges, IKnowledges[]>
  implements StaticImplements<INeedRefresh, typeof KnowledgesFAQService>
{
  public get needRefresh(): { value: boolean } {
    return KnowledgesFAQService._needRefresh;
  }
  public static _needRefresh = {
    value: true,
  };
  constructor(protected dataService: DataService, protected knKeyValue: KnowledgeKeyValueService, private accountService: AccountService) {
    super(dataService);
  }

  protected clearWatch(): void {
    this.data$ = new BehaviorSubject<IKnowledges[]>([]);
  }

  protected initWatch(): void {
    this.data$.next([]);
  }

  protected setupDataParameters(): void {
    this.defaultDataParameter = {
      entityPrefix: "knowledges_faq_",
      entityStoreKey: "list",
      getUrl: "/knowledges/faq",
      setUrl: null,
      expirationDays: 10,
      encrypted: false,
    };
  }

  public async *getDataReader(): AsyncGenerator<IKnowledges[], IKnowledges[], IKnowledges[]> {
    try {
      if (this.accountService.isOnlyRelated) {
        yield [];
        return [];
      }
      const dataReader = super.getDataReader();
      let d: IKnowledges[] = [];
      for await (const data of dataReader) {
        d = this.processData(data);
        yield d;
      }
      return d;
    } catch (err) {
      FileLogger.error("KnowledgesFAQService", "getDataReader()", err);
      yield [];
      return [];
    }
  }

  private processData(dataResult: IKnowledges[]) {
    const kn = dataResult;
    try {
      const filteredData = Tools.deepCopy(dataResult);
      return filteredData;
    } catch (err) {
      FileLogger.error("KnowledgesFAQService", "Error while processing KnowledgesFAQService data: ", err);
    }
    return kn;
  }

  public async getFreshestKnowledgeFAQToKeyValue(onlyThreeStars = false): Promise<IKeyValue[]> {
    return this.knKeyValue.getFreshestKnowledgeToKeyValue(onlyThreeStars, this.getDataReader());
  }
}
